import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { MinubaSettings, SendCaseSettings } from '../inbox-data';

@Component({
  selector: 'app-minuba-settings',
  templateUrl: './minuba-settings.component.html'
})
export class MinubaSettingsComponent implements OnInit {

  @Input() data: SendCaseSettings;
  minubaSettings: MinubaSettings = new MinubaSettings();
  @Output() update = new EventEmitter();
  companyUsers;
  responsibles;

  constructor(private http: HttpClient, private sharedData: SharedDataService) { }

  ngOnInit(): void {
    this.sharedData.responsibles().subscribe((data) => { 
      this.responsibles = data; 
      console.log(data) 
    });
    this.sharedData.minubaSettings().subscribe((data) => { 
      this.minubaSettings = data; 
      console.log(data);
      this.reset();
    });
  }

  reset() {
    this.data = {
      ...new SendCaseSettings(),
      responsibleId: localStorage.getItem('bearer'),
      integrationId: '2fdf7795-d8dc-4dcc-863b-9654ef98b1a0',
      caseId: this.data.caseId,
      minubaCaseType: this.data.minubaCaseType
    }
    //console.log(this.data);
  }

  updateParent() {
    //console.log(this.data);
    this.update.emit(this.data);
  }

}
